import { useEffect, useState } from "react";
import { Navigate, Route, Routes, useNavigate } from "react-router-dom";
import AppShell from "./components/AppShell";
import { ToastHost } from "./components/Ui";
import { auth } from "./lib/api";
import AccountsPage from "./pages/AccountsPage";
import ApiKeysPage from "./pages/ApiKeysPage";
import DashboardPage from "./pages/DashboardPage";
import LoginPage from "./pages/LoginPage";
import LogsPage from "./pages/LogsPage";
import MetricsPage from "./pages/MetricsPage";
import SettingsPage from "./pages/SettingsPage";
import GoogleMaxBatchPage from "./pages/GoogleMaxBatchPage";
import TasksPage from "./pages/TasksPage";
import WorkersPage from "./pages/WorkersPage";

export default function App() {
  return (
    <>
      <Routes>
        <Route path="/login" element={<LoginPage />} />
        <Route path="/*" element={<ProtectedApplication />} />
      </Routes>
      <ToastHost />
    </>
  );
}

function ProtectedApplication() {
  const navigate = useNavigate();
  const [authenticated, setAuthenticated] = useState(auth.isAuthenticated());
  useEffect(() => {
    const unauthorized = () => {
      setAuthenticated(false);
      navigate("/login", { replace: true });
    };
    window.addEventListener("admin:unauthorized", unauthorized);
    return () => window.removeEventListener("admin:unauthorized", unauthorized);
  }, [navigate]);

  if (!authenticated) return <Navigate to="/login" replace />;
  return (
    <AppShell>
      <Routes>
        <Route index element={<DashboardPage />} />
        <Route path="accounts" element={<AccountsPage />} />
        <Route path="google-max" element={<GoogleMaxBatchPage />} />
        <Route path="tasks" element={<TasksPage />} />
        <Route path="api-keys" element={<ApiKeysPage />} />
        <Route path="logs" element={<LogsPage />} />
        <Route path="workers" element={<WorkersPage />} />
        <Route path="metrics" element={<MetricsPage />} />
        <Route path="settings" element={<SettingsPage />} />
        <Route path="*" element={<Navigate to="/" replace />} />
      </Routes>
    </AppShell>
  );
}
